import React, { useState } from "react";
import { API_BASE_URL } from "../../config";
import { Modal, Button, Label, TextInput, Checkbox } from "flowbite-react";
import { useNavigate } from "react-router-dom";

const ModalRegistro = ({ closeModal, onSuccess }) => {
  const navigate = useNavigate();
  const [view, setView] = useState("register");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    nombre: "",
    telefono: "",
    suscrito_mailing: true,
    whatsapp_notificaciones: true,
  });

  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Manejar cambios en los campos de entrada
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


const enviarEmailBienvenida = async (nombre, email, telefono) => {
  try {
    const response = await fetch(`${API_BASE_URL}/usuarios/send-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre,
        email,
        telefono,
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("❌ Error al enviar email:", data.error);
    }
  } catch (error) {
    console.error("❌ Error de conexión con el servidor:", error);
  }
};



const guardarYRedirigir = (usuario_id) => {
  if (!usuario_id) {
    console.error("❌ Error: usuario_id no recibido.");
    setError("Error al obtener usuario_id.");
    return;
  }

  // 🚀 Obtener cliente_id desde URL o LocalStorage
  const urlParams = new URLSearchParams(window.location.search);
  let clienteId = urlParams.get("menu") || localStorage.getItem("cliente_id");

  if (!clienteId) {
    console.warn("⚠️ No hay cliente_id en URL ni en localStorage, redirección genérica.");
    navigate(`/restaurante/seleccion`);  // Si no hay cliente_id, redirigir a una vista de selección
    return;
  }

  // ✅ Guardar usuario_id y cliente_id en localStorage
  localStorage.setItem("usuario_id", usuario_id);
  localStorage.setItem("cliente_id", clienteId);

  console.log("✅ Redirigiendo a:", `/restaurante/${clienteId}/menu`);
  navigate(`/restaurante/${clienteId}/menu`);
};

  // 🔹 **Registrar un nuevo usuario**
const handleRegister = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMensaje("");
  setError("");

  try {
    const response = await fetch(`${API_BASE_URL}/usuarios/registro`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre: formData.nombre,
        email: formData.email,
        telefono: formData.telefono,
        password: formData.password,
      }),
    });

    const data = await response.json();
    if (response.ok) {
      localStorage.setItem("token", data.token);  // Guardar token en localStorage
      guardarYRedirigir(data.usuario_id);
      enviarEmailBienvenida(formData.nombre, formData.email, formData.telefono);  // ✅ Enviar email de bienvenida
      closeModal();
    } else {
      setError(data.error || "Error en el registro.");
    }
  } catch (error) {
    setError("Error de conexión con el servidor.");
  } finally {
    setLoading(false);
  }
};

  // 🔹 **Iniciar sesión**
const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje("");
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login-usuario`, {  // 🔹 URL corregida
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, password: formData.password }),
      });

      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("token", data.token); // Guardar token
        guardarYRedirigir(data.usuario_id);
        closeModal();
      } else {
        setError(data.error || "Error en el inicio de sesión.");
      }
    } catch (error) {
      setError("Error de conexión con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={true} onClose={closeModal} size="lg">
      <Modal.Header>
        {view === "register" ? "🚀 Crear Cuenta" : "🔐 Iniciar Sesión"}
      </Modal.Header>
      <Modal.Body>
        {mensaje && <p className="text-green-600 text-center">{mensaje}</p>}
        {error && <p className="text-red-600 text-center">{error}</p>}

        {view === "register" ? (
          <form onSubmit={handleRegister} className="space-y-4">
            <div>
              <Label htmlFor="nombre">Nombre Completo</Label>
              <TextInput type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <TextInput type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div>
              <Label htmlFor="password">Contraseña</Label>
              <TextInput type="password" id="password" name="password" value={formData.password} onChange={handleChange} />
            </div>
            <Button type="submit" gradientDuoTone="greenToBlue" disabled={loading}>
              {loading ? "Registrando..." : "🚀 Registrarse"}
            </Button>
            <p className="text-center text-sm text-gray-600 mt-4">
              ¿Ya tienes cuenta?{" "}
              <span className="text-blue-500 cursor-pointer" onClick={() => setView("login")}>
                Inicia sesión aquí
              </span>
            </p>
          </form>
        ) : (
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <TextInput type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div>
              <Label htmlFor="password">Contraseña</Label>
              <TextInput type="password" id="password" name="password" value={formData.password} onChange={handleChange} />
            </div>
            <Button type="submit" gradientDuoTone="pinkToOrange" disabled={loading}>
              {loading ? "Verificando..." : "🔐 Iniciar Sesión"}
            </Button>
            <p className="text-center text-sm text-gray-600 mt-4">
              ¿No tienes cuenta?{" "}
              <span className="text-blue-500 cursor-pointer" onClick={() => setView("register")}>
                Regístrate aquí
              </span>
            </p>
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalRegistro;
